import Create from '../create'
import swal from 'sweetalert'
import Status from '@/components/status'
export default {
  name: 'list',
  components: {Create, Status},
  props: [],
  data () {
    return {
      group: {},
      errors: {},
      btn_submit: false
    }
  },
  computed: {
    data () {
      return this.$store.getters['Group/getListGroup']
    },
    options () {
      return this.$store.getters['Status/getStatusCheckerMaker']
    }
  },
  mounted () {
  
    Promise.all([
      this.$store.dispatch('Group/getListGroup', {}),
      this.$store.dispatch('Status/getListStatus')
    ]).then(res => {
      
    }).catch(errors => {
      
    })
  },
  methods: {
    showModalEdit (group) {
    
      this.$store.dispatch('Group/showGroup', {group: group}).then(res => {
        this.group = res
        this.$refs.edit.show()
        
      }).catch(errors => {
        
      })
    },

    edit () {
    
      this.$store.dispatch('Group/updateGroup', {group: this.group}).then(res => {
        this.$refs.edit.hide()
        this.$notify({
          group: 'success',
          title: this.$t('notify.notify'),
          text: this.$t('notify.update_success')
        })
        
      }).catch(errors => {
        if (errors.status === 422) {
          this.errors = errors.data.error
        }
        
      })
    },

    destroy (group) {
      swal({
        title: this.$t('notify.delete_comfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      })
        .then((willDelete) => {
          if (willDelete) {
          
            this.$store.dispatch('Group/destroyGroup', {
              group
            }).then((res) => {
              this.$notify({
                group: 'success',
                title: this.$t('notify.notify'),
                text: this.$t('notify.delete_success')
              })
            }).catch(errors => { })
            
          }
        })
    },
    permission (group) {
      this.$router.push('/group/' + group.id + '/permission')
    },
    menu (group) {
      this.$router.push('/group/' + group.id + '/menu')
    },
    dashboard (group) {
      this.$router.push('/group/' + group.id + '/dashboard')
    },
    user (group) {
      this.$router.push('/user/list?group_id=' + group.id)
    },
    approval (group) {
    
      this.$store.dispatch('Group/approvalGroup', {
        group
      }).then(res => {
        group.status = res.status
        
      }).catch(errors => {
        
      })
    },

    rejection (group) {
    
      this.$store.dispatch('Group/rejectGroup', {
        group
      }).then(res => {
        group.status = res.status
        
      }).catch(errors => {
        
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/group/list/list.js